import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import ChatbotWidget from './components/ChatbotWidget';
import { ThemeProvider } from './theme/themeContext';

export default function App(){
  return (
    <ThemeProvider>
      <div className="min-h-screen antialiased">
        <Header />
        <main className="pt-20">
          <Hero />
          <div className="max-w-6xl mx-auto p-4 space-y-20">
            <About />
            <Skills />
            <Experience />
            <Projects />
            <Contact />
          </div>
        </main>
        <ChatbotWidget />
      </div>
    </ThemeProvider>
  )
}
